const tooltipHomepageText=[
    "The Teacher Demo id does not have access to the game.",
    "The Teacher Demo id does not have acess to Extra Credit."
];
export default tooltipHomepageText;